<template>
  <div
    class="user-item pa-1"
    :class="{
      'custom-color':  user.unread_count != 0 
    }"
    style="border: none; height: 84px; display: flex; align-items: center;"
  >
  
  {{ user.member_id }}
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <template v-if="user.profile_pic">
          <img class="profilePic" :src="user.profile_pic" alt @error="imgError(this)" />
          <!-- <img class="profile" :src="user.profile_pic" alt @error="imgError(this)" /> -->
        </template>
        <template v-else>
          <img class="profilePic" src="/static/img/assets/livechat/profile.png" alt />
          <!-- <img class="profile" src="/static/img/assets/livechat/profile.png" alt /> -->
        </template>
      </v-list-tile-avatar>

      <!-- ชื่อ User -->
      <v-list-tile-content>
        <v-list-tile-title :class="{ unreadmessage: !user.adminread }" style="text-overflow: ellipsis; overflow-x: hidden; width: 90%; color: #0C2F53; font-weight: 700; font-size: 16px;">{{
          user.first_name + ' ' + user.last_name
        }}</v-list-tile-title>

        <!-- ใต้ชื่อ User -->
        <v-list-tile-sub-title
          class="caption #0C2F53--text text--"
          :class="{ unreadmessage: !user.adminread }"
          style="font-weight: 500; font-size: 14px; color: #0C2F53; width: 190px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
        >
          <!-- {{ dayLeft(user.lastreply_time) }} -->
          {{ lastmessage() }}
        </v-list-tile-sub-title>
      </v-list-tile-content>

      <!-- แจ้งเตือนจำนวนข้อความที่ยังไม่ได้อ่าน -->
      <div v-if="user.unread_count != 0" style="position: absolute; right: -20px; top: 27px; display: flex; align-items: center; justify-content: center; 
                  border-radius: 15px; width: 29px; height: 24px; padding: 3px; color: #0C2F53;  border: none;
                  background-color: rgba(12, 47, 83, 0.3); font-size: 12px; font-weight: 700; font-family:'Sukhumvit';">  
      {{ user.unread_count }} 
    </div>

    </v-list-tile>
    <div v-if="currentTheme == 'ticket'" class="text-xs-right">
      <v-chip v-if="user.status == 'cancelled'" small color="error" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'closed'" small color="grey" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'pendding'" small color="warning" dark class="caption">{{
        user.status
      }}</v-chip>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'selected', 'livechatUsersData'],
  data: function() {
    return {
      user: this.value,
      hasNewMessage: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    currentTheme() {
      console.log('user', this.user)
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    userRealname: {
      get() {
        if (this.value && this.value.realname) {
          return this.value.realname
        } else
          return (
            (this.value.first_name ? this.value.first_name : '') +
            (this.value.last_name ? ' ' + this.value.last_name : '')
          )
      },
      set(val) {
        this.value.realname
      }
    }
  },
  mounted () {
    // console.log("this.livechatUsersData", this.livechatUsersData.lastmessagedata)
    // console.log("this.livechatUsersType", this.livechatUsersData.lastmessagetype)
    // console.log("this.user.unread_count", this.user.unread_count)
    this.lastmessage()
  },
  filters: {
    time: function(date) {
      if (typeof date === 'string') {
        date = moment(date)
      }
      return date.format('h:mm A')
    }
  },
  methods: {
    lastmessage() {
      let lastmessageData = this.livechatUsersData.lastmessagedata
      let lastmessageType = this.livechatUsersData.lastmessagetype
      let userName = this.livechatUsersData.first_name + this.livechatUsersData.last_name

      // console.log(userName)
      // console.log(lastmessageData)
      // console.log(lastmessageType)
      if (lastmessageType == 'text')                 return lastmessageData
      else if (lastmessageType == 'button')          return lastmessageData
      else if (lastmessageType == 'image')           return userName + " ส่งรูปภาพ"
      else if (lastmessageType == 'video')           return userName + " ส่งวิดีโอ"
      else if (lastmessageType == 'audio')           return userName + " ส่งข้อความเสียง"
      else if (lastmessageType == 'payment')         return "ข้อมูลการชำระเงิน"
      else if (lastmessageType == 'generic')         return "คุณได้รับข้อความใหม่"
      else if (lastmessageType == 'welcome_message') return lastmessageData
      else if (lastmessageType == 'responsepost')    return lastmessageData
      else if (lastmessageType == 'flex')            return "คุณได้รับข้อความใหม่"
      else if (lastmessageType == 'imagemap')        return "คุณได้รับข้อความใหม่"
      else if (lastmessageType == 'sticker')         return userName + " ส่งสติกเกอร์"
      else if (lastmessageType == 'file')            return userName + " ส่งไฟล์"
      else if (lastmessageType == 'json') {
        lastmessageData = JSON.parse(lastmessageData)
        while ( lastmessageData.length != undefined) lastmessageData = lastmessageData[lastmessageData.length - 1]
        lastmessageType = lastmessageData.type
        // console.log(lastmessageData)
        // console.log(lastmessageType)
        if(lastmessageType == 'text' || lastmessageType == 'button') return lastmessageData.text
        else if (lastmessageType == 'image')                         return "คุณส่งรูป"
        else if (lastmessageType == 'video')                         return "คุณส่งวิดีโอ"
        else if (lastmessageType == 'audio')                         return "คุณส่งข้อความเสียง"
        else if (lastmessageType == 'payment')                       return "ข้อมูลการชำระเงิน"
        else if (lastmessageType == 'generic')                       return "คุณได้รับข้อความใหม่"
        else if (lastmessageType == 'welcome_message')               return lastmessageData.text
        else if (lastmessageType == 'responsepost')                  return lastmessageData.text
        else if (lastmessageType == 'flex')                          return "คุณได้รับข้อความใหม่"
        else if (lastmessageType == 'imagemap')                      return "คุณได้รับข้อความใหม่"
        else if (lastmessageType == 'sticker')                       return "คุณส่งสติกเกอร์"
        else if (lastmessageType == 'file')                          return "คุณส่งไฟล์"
      }
    },
    imgError: function(event, el) {
      // console.log('not load')
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    dayLeft: function(replytime) {
      var lastreply = moment(replytime)
      var currentDate = moment()

      var time = ''
      if (currentDate.diff(lastreply, 'days') > 0) {
        time = lastreply.format('DD MMM YYYY')
      } else if (currentDate.diff(lastreply, 'hours') > 0) {
        time = currentDate.diff(lastreply, 'hours')
        time += ' ' + this.$t('Hours')
      } else if (currentDate.diff(lastreply, 'minutes') > 0) {
        time = currentDate.diff(lastreply, 'minutes')
        time += ' ' + this.$t('Minutes')
      } else if (currentDate.diff(lastreply, 'seconds') > 0) {
        time = currentDate.diff(lastreply, 'seconds')
        time += ' ' + this.$t('Seconds')
      }
      return time
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.user = this.value
      if (newVal.lastreply_time != oldVal.lastreply_time) {
        if (this.selected != true) {
          this.hasNewMessage = true
        }
      }
    },
    selected: function(newVal, oldVal) {
      this.user.unread_count = 0
      // console.log("this.user.unread_count",this.user.unread_count)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-item {
  .active {
  };
  position: relative;
}

.user-item::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 5%;
  width: 90%;
  height: 1px;
  background-color: #BDBDBD;
}
.unreadmessage {
  color: #0C2F53 !important;
  font-weight: bold;
}
.custom-color {
  background-color: #E6F0FB;
}

.profilePic {
  width: 51px;
  height: 51px;
}

.profilePicSelected {
  width: 65px;
  height: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue